// extracted by mini-css-extract-plugin
module.exports = {"header-main":"welcomeHeader_header-main__1uuNy"};